import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalFormDetailResponse } from "./types";

// GET /api/portal/forms/:slug — partner-side detail.
//
// Returns the form definition AND the partner's in-progress draft for the
// form (the worker auto-creates one on first call; subsequent calls return
// the same draft via the partial unique index). The orchestrator hook
// consumes `data.draft.submissionId` for subsequent PATCH/POST mutations.
export function useFormDetail(slug: string | undefined) {
  return useQuery<PortalFormDetailResponse, ApiClientError>({
    queryKey: queryKeys.portal.forms.detail(slug ?? ""),
    queryFn: () =>
      apiFetch<PortalFormDetailResponse>(`/portal/forms/${slug}`),
    enabled: !!slug,
  });
}
